/**
 * localStorage-backed wishlist (no account/app required, does not sync across devices
 * — see project decision). Stores {id, handle} pairs so the wishlist page can later
 * fetch full product data via /products/{handle}.js.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'theme:wishlist';

  function getAll() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function save(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
  }

  function has(id) {
    return getAll().some(function (item) { return String(item.id) === String(id); });
  }

  function toggle(id, handle) {
    var items = getAll();
    var index = items.findIndex(function (item) { return String(item.id) === String(id); });
    var added;
    if (index > -1) {
      items.splice(index, 1);
      added = false;
    } else {
      items.push({ id: id, handle: handle });
      added = true;
    }
    save(items);
    document.dispatchEvent(new CustomEvent('theme:wishlist:change', { detail: { items: items } }));
    return added;
  }

  function remove(id) {
    var items = getAll().filter(function (item) { return String(item.id) !== String(id); });
    save(items);
    document.dispatchEvent(new CustomEvent('theme:wishlist:change', { detail: { items: items } }));
  }

  function updateButtonState(btn, active) {
    var icon = btn.querySelector('.icon');
    btn.closest('li, button').classList.toggle('addwishlist', active);
    if (icon) {
      icon.classList.toggle('icon-Hearth', !active);
      icon.classList.toggle('icon-HearthFill', active);
    }
    var label = btn.querySelector('.tooltip, .text-wish');
    if (label) {
      label.textContent = active
        ? (window.themeStrings ? window.themeStrings.removeWishlist : 'Remove Wishlist')
        : (window.themeStrings ? window.themeStrings.addWishlist : 'Add to Wishlist');
    }
  }

  function refreshAllButtons() {
    document.querySelectorAll('.js-wishlist-toggle[data-product-id]').forEach(function (btn) {
      updateButtonState(btn, has(btn.getAttribute('data-product-id')));
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = getAll().length;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-wishlist-toggle');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-product-id');
    if (!id) return;
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) {
      var card = btn.closest('[data-product-handle]');
      handle = card ? card.getAttribute('data-product-handle') : '';
    }
    var active = toggle(id, handle);
    document.querySelectorAll('.js-wishlist-toggle[data-product-id="' + id + '"]').forEach(function (b) {
      updateButtonState(b, active);
    });
  });

  document.addEventListener('DOMContentLoaded', refreshAllButtons);
  document.addEventListener('theme:wishlist:change', refreshAllButtons);

  window.themeWishlist = {
    getAll: getAll,
    has: has,
    toggle: toggle,
    remove: remove,
    refreshAllButtons: refreshAllButtons
  };
})();
